import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-radio"
export default class extends Controller {

  static targets = ["icecast", "shoutcast",
     'checkIcecast',
     'checkeShoutcast',
     "outShoutcast", "outIcecast"];

  connect() {
    const shoutcast = this.shoutcastTarget
    const icecast = this.icecastTarget
    const out_shoutcast = this.outShoutcastTarget
    const out_icecast = this.outIcecastTarget
   

    console.log(out_shoutcast.value);


    if (out_shoutcast.value == "https://") {
      shoutcast.classList.add("hidden");
    }

    if (out_icecast.value == "https://") {
      icecast.classList.add("hidden");
     
    }

     


  }

  shoutcast() {

    this.shoutcastTarget.classList.remove("hidden");
    this.icecastTarget.classList.add("hidden");
    this.outIcecastTarget.value = "https://"
    this.checkedTarget = false
  }

  icecast() {
    this.icecastTarget.classList.remove("hidden");
    this.shoutcastTarget.classList.add("hidden");
    this.outShoutcastTarget.value = "https://"
    this.checkedTarget = false
  }

}
